module.exports = __webpack_public_path__ + "assets/img/zh-Hant-2d91d43b.png";